import {Chart} from 'chart.js'
import 'chartjs-adapter-date-fns'
import { LineController, LinearScale, CategoryScale, TimeScale, Title, PointElement, LineElement, BarElement, Tooltip, Filler, Legend, BarController} from 'chart.js';
Chart.register(LineController, LinearScale, CategoryScale, TimeScale, Title, PointElement, LineElement, BarElement, Tooltip, Filler, Legend, BarController);

export function makeChart(element, {
    type,
    data,
    title,
    xAxis: {labelType, stepUnit, title: xLabel, offset, ticks = {}} = {},
    yAxis: {stacked, max, title: yLabel} = {}
}) {
    console.log(labelType);
    return new Chart(element, {
        type,
        data,
        options: {
            interaction: {
                mode: 'point'
            },
            plugins: {
                title: {
                    display: !!title,
                    text: title || ''
                }
            },
            scales: {
                x: {
                    title: xLabel,
                    type: labelType,
                    time: {
                        unit: 'hour',
                        tooltipFormat: 'dd.MM.yyyy HH:mm',
                        displayFormats: {
                            day: 'dd.MM',
                            hour: 'HH:mm'
                        },
                    },
                    offset,
                    ticks : {
                        maxRotation: 90,
                        major: {
                            enabled: true,
                            unit: 'day'
                        },
                        font: function (context) {
                            if (context.tick && context.tick.major) {
                                return {
                                    weight: 'bold',
                                };
                            }
                        }
                    },

                },
                y: {
                    stacked,
                    beginAtZero: true,
                    max: max || undefined,
                    title: yLabel
                },
            },
            tooltips: {
                callbacks: {
                    label(data) {
                        const dataset = data.dataset
                        const dd = dataset.data[data.dataIndex]
                        let label = `${dataset.label}: ${data.formattedValue}`

                        if (dd.count) label += `, # ${dd.count}`
                        return label
                    }
                }
            },
            maintainAspectRatio: false,
            responsive: true,
        }
    })
}

export {
    Chart
}
export * from 'chart.js/helpers'
